import { createContext } from 'react';
import { IDeleteApkFirmwareValidationError, IServerError, ICredentials } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export type TSortBy = '' | 'NameA-Z' | 'NameZ-A';
export type TCountOfItems = '12' | '24' | '48';
export interface IFilterValues {
	searchString: string;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface ICredentialsState {
	credentials: ICredentials;
	searchString: string;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponseData: IServerError<IDeleteApkFirmwareValidationError> | null;
}

export const credentialsInitialState: ICredentialsState = {
	credentials: {
		credentialItems: [],
		count: 0,
	},
	searchString: '',
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface ICredentialsContext extends ICredentialsState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setFiltersFromQueryString(value: IFilterValues): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	showErrorModalWithInfo(value: IServerError<IDeleteApkFirmwareValidationError> | null): void;
}

export const CredentialsContext = createContext<ICredentialsContext>({
	deleteSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	resetSelectedControls: () => undefined,
	setFiltersFromQueryString: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	...credentialsInitialState,
});
